export const RECORDING_EXPERIENCE_DATA = [
  {
    id: 1,
    from: 0,
    to: 0,
    range: '[0, 0]',
    orderIndex: 1,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2020-04-02T09:10:42.082Z',
  },
  {
    id: 2,
    from: 1,
    to: 10,
    range: '[1, 10]',
    orderIndex: 2,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2020-04-02T09:10:42.082Z',
  },
  {
    id: 3,
    from: 11,
    to: 50,
    range: '[11, 50]',
    orderIndex: 3,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2020-04-02T09:10:42.082Z',
  },
  {
    id: 4,
    from: 51,
    to: 100,
    range: '[51, 100]',
    orderIndex: 4,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2020-04-02T09:10:42.082Z',
  },
  {
    id: 5,
    from: 101,
    to: 999,
    range: '[101, 999]',
    orderIndex: 5,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2020-04-02T09:10:42.082Z',
  },
];

export const VOICE_AGE_RANGE_DATA = [
  {
    id: 1,
    from: 1,
    to: 12,
    range: '[1, 12]',
    orderIndex: 1,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 2,
    from: 13,
    to: 19,
    range: '[13, 19]',
    orderIndex: 2,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 3,
    from: 20,
    to: 39,
    range: '[20, 39]',
    orderIndex: 3,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 4,
    from: 40,
    to: 59,
    range: '[40, 59]',
    orderIndex: 4,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 5,
    from: 60,
    to: 79,
    range: '[60, 79]',
    orderIndex: 5,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 6,
    from: 80,
    to: 99,
    range: '[80, 99]',
    orderIndex: 6,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
];

export const COUNTRY_DATA = [
  {
    id: 1,
    name: 'Afghanistan',
    orderIndex: 1,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 2,
    name: 'Åland Islands',
    orderIndex: 2,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 3,
    name: 'Albania',
    orderIndex: 3,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 4,
    name: 'Algeria',
    orderIndex: 4,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 5,
    name: 'American Samoa',
    orderIndex: 5,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 6,
    name: 'Andorra',
    orderIndex: 6,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 7,
    name: 'Angola',
    orderIndex: 7,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 8,
    name: 'Anguilla',
    orderIndex: 8,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 9,
    name: 'Antarctica',
    orderIndex: 9,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 10,
    name: 'Antigua and Barbuda',
    orderIndex: 10,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 11,
    name: 'Argentina',
    orderIndex: 11,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 12,
    name: 'Armenia',
    orderIndex: 12,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 13,
    name: 'Aruba',
    orderIndex: 13,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 14,
    name: 'Australia',
    orderIndex: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 15,
    name: 'Austria',
    orderIndex: 15,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 16,
    name: 'Azerbaijan',
    orderIndex: 16,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 17,
    name: 'Bahamas',
    orderIndex: 17,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 18,
    name: 'Bahrain',
    orderIndex: 18,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 19,
    name: 'Bangladesh',
    orderIndex: 19,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 20,
    name: 'Barbados',
    orderIndex: 20,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 21,
    name: 'Belarus',
    orderIndex: 21,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 22,
    name: 'Belgium',
    orderIndex: 22,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 23,
    name: 'Belize',
    orderIndex: 23,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 24,
    name: 'Benin',
    orderIndex: 24,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 25,
    name: 'Bermuda',
    orderIndex: 25,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 26,
    name: 'Bhutan',
    orderIndex: 26,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 27,
    name: 'Bolivia',
    orderIndex: 27,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 28,
    name: 'Bosnia and Herzegovina',
    orderIndex: 28,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 29,
    name: 'Botswana',
    orderIndex: 29,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 30,
    name: 'Bouvet Island',
    orderIndex: 30,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 31,
    name: 'Brazil',
    orderIndex: 31,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 32,
    name: 'British Indian Ocean Territory',
    orderIndex: 32,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 33,
    name: 'Brunei Darussalam',
    orderIndex: 33,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 34,
    name: 'Bulgaria',
    orderIndex: 34,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 35,
    name: 'Burkina Faso',
    orderIndex: 35,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 36,
    name: 'Burundi',
    orderIndex: 36,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 37,
    name: 'Cambodia',
    orderIndex: 37,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 38,
    name: 'Cameroon',
    orderIndex: 38,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 39,
    name: 'Canada',
    orderIndex: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 40,
    name: 'Cape Verde',
    orderIndex: 40,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 41,
    name: 'Cayman Islands',
    orderIndex: 41,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 42,
    name: 'Central African Republic',
    orderIndex: 42,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 43,
    name: 'Chad',
    orderIndex: 43,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 44,
    name: 'Chile',
    orderIndex: 44,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 45,
    name: 'China',
    orderIndex: 45,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 46,
    name: 'Christmas Island',
    orderIndex: 46,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 47,
    name: 'Cocos (Keeling) Islands',
    orderIndex: 47,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 48,
    name: 'Colombia',
    orderIndex: 48,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 49,
    name: 'Comoros',
    orderIndex: 49,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 50,
    name: 'Congo',
    orderIndex: 50,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 51,
    name: 'Congo, The Democratic Republic of the',
    orderIndex: 51,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 52,
    name: 'Cook Islands',
    orderIndex: 52,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 53,
    name: 'Costa Rica',
    orderIndex: 53,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 54,
    name: "Cote D'Ivoire",
    orderIndex: 54,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 55,
    name: 'Croatia',
    orderIndex: 55,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 56,
    name: 'Cuba',
    orderIndex: 56,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 57,
    name: 'Cyprus',
    orderIndex: 57,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 58,
    name: 'Czech Republic',
    orderIndex: 58,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 59,
    name: 'Denmark',
    orderIndex: 59,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 60,
    name: 'Djibouti',
    orderIndex: 60,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 61,
    name: 'Dominica',
    orderIndex: 61,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 62,
    name: 'Dominican Republic',
    orderIndex: 62,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 63,
    name: 'Ecuador',
    orderIndex: 63,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 64,
    name: 'Egypt',
    orderIndex: 64,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 65,
    name: 'El Salvador',
    orderIndex: 65,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 66,
    name: 'Equatorial Guinea',
    orderIndex: 66,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 67,
    name: 'Eritrea',
    orderIndex: 67,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 68,
    name: 'Estonia',
    orderIndex: 68,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 69,
    name: 'Ethiopia',
    orderIndex: 69,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 70,
    name: 'Falkland Islands (Malvinas)',
    orderIndex: 70,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 71,
    name: 'Faroe Islands',
    orderIndex: 71,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 72,
    name: 'Fiji',
    orderIndex: 72,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 73,
    name: 'Finland',
    orderIndex: 73,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 74,
    name: 'France',
    orderIndex: 74,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 75,
    name: 'French Guiana',
    orderIndex: 75,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 76,
    name: 'French Polynesia',
    orderIndex: 76,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 77,
    name: 'French Southern Territories',
    orderIndex: 77,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 78,
    name: 'Gabon',
    orderIndex: 78,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 79,
    name: 'Gambia',
    orderIndex: 79,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 80,
    name: 'Georgia',
    orderIndex: 80,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 81,
    name: 'Germany',
    orderIndex: 81,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 82,
    name: 'Ghana',
    orderIndex: 82,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 83,
    name: 'Gibraltar',
    orderIndex: 83,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 84,
    name: 'Greece',
    orderIndex: 84,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 85,
    name: 'Greenland',
    orderIndex: 85,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 86,
    name: 'Grenada',
    orderIndex: 86,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 87,
    name: 'Guadeloupe',
    orderIndex: 87,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 88,
    name: 'Guam',
    orderIndex: 88,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 89,
    name: 'Guatemala',
    orderIndex: 89,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 90,
    name: 'Guernsey',
    orderIndex: 90,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 91,
    name: 'Guinea',
    orderIndex: 91,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 92,
    name: 'Guinea-Bissau',
    orderIndex: 92,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 93,
    name: 'Guyana',
    orderIndex: 93,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 94,
    name: 'Haiti',
    orderIndex: 94,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 95,
    name: 'Heard Island and Mcdonald Islands',
    orderIndex: 95,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 96,
    name: 'Holy See (Vatican City State)',
    orderIndex: 96,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 97,
    name: 'Honduras',
    orderIndex: 97,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 98,
    name: 'Hong Kong',
    orderIndex: 98,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 99,
    name: 'Hungary',
    orderIndex: 99,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 100,
    name: 'Iceland',
    orderIndex: 100,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 101,
    name: 'India',
    orderIndex: 101,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 102,
    name: 'Indonesia',
    orderIndex: 102,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 103,
    name: 'Iran, Islamic Republic Of',
    orderIndex: 103,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 104,
    name: 'Iraq',
    orderIndex: 104,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 105,
    name: 'Ireland',
    orderIndex: 105,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 106,
    name: 'Isle of Man',
    orderIndex: 106,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 107,
    name: 'Israel',
    orderIndex: 107,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 108,
    name: 'Italy',
    orderIndex: 108,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 109,
    name: 'Jamaica',
    orderIndex: 109,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 110,
    name: 'Japan',
    orderIndex: 110,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 111,
    name: 'Jersey',
    orderIndex: 111,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 112,
    name: 'Jordan',
    orderIndex: 112,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 113,
    name: 'Kazakhstan',
    orderIndex: 113,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 114,
    name: 'Kenya',
    orderIndex: 114,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 115,
    name: 'Kiribati',
    orderIndex: 115,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 116,
    name: "Democratic People's Republic of Korea",
    orderIndex: 116,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 117,
    name: 'Korea, Republic of',
    orderIndex: 117,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 118,
    name: 'Kosovo',
    orderIndex: 118,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 119,
    name: 'Kuwait',
    orderIndex: 119,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 120,
    name: 'Kyrgyzstan',
    orderIndex: 120,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 121,
    name: "Lao People's Democratic Republic",
    orderIndex: 121,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 122,
    name: 'Latvia',
    orderIndex: 122,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 123,
    name: 'Lebanon',
    orderIndex: 123,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 124,
    name: 'Lesotho',
    orderIndex: 124,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 126,
    name: 'Liberia',
    orderIndex: 126,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 127,
    name: 'Libyan Arab Jamahiriya',
    orderIndex: 127,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 128,
    name: 'Liechtenstein',
    orderIndex: 128,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 129,
    name: 'Lithuania',
    orderIndex: 129,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 130,
    name: 'Luxembourg',
    orderIndex: 130,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 131,
    name: 'Macao',
    orderIndex: 131,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 132,
    name: 'Macedonia, The Former Yugoslav Republic of',
    orderIndex: 132,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 133,
    name: 'Madagascar',
    orderIndex: 133,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 134,
    name: 'Malawi',
    orderIndex: 134,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 135,
    name: 'Malaysia',
    orderIndex: 135,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 136,
    name: 'Maldives',
    orderIndex: 136,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 137,
    name: 'Mali',
    orderIndex: 137,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 138,
    name: 'Malta',
    orderIndex: 138,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 139,
    name: 'Marshall Islands',
    orderIndex: 139,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 140,
    name: 'Martinique',
    orderIndex: 140,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 141,
    name: 'Mauritania',
    orderIndex: 141,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 142,
    name: 'Mauritius',
    orderIndex: 142,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 143,
    name: 'Mayotte',
    orderIndex: 143,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 144,
    name: 'Mexico',
    orderIndex: 144,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 145,
    name: 'Micronesia, Federated States of',
    orderIndex: 145,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 146,
    name: 'Moldova, Republic of',
    orderIndex: 146,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 147,
    name: 'Monaco',
    orderIndex: 147,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 148,
    name: 'Mongolia',
    orderIndex: 148,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 149,
    name: 'Montenegro',
    orderIndex: 149,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 150,
    name: 'Montserrat',
    orderIndex: 150,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 151,
    name: 'Morocco',
    orderIndex: 151,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 152,
    name: 'Mozambique',
    orderIndex: 152,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 153,
    name: 'Myanmar',
    orderIndex: 153,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 154,
    name: 'Namibia',
    orderIndex: 154,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 155,
    name: 'Nauru',
    orderIndex: 155,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 156,
    name: 'Nepal',
    orderIndex: 156,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 157,
    name: 'Netherlands',
    orderIndex: 157,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 158,
    name: 'Netherlands Antilles',
    orderIndex: 158,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 159,
    name: 'New Caledonia',
    orderIndex: 159,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 160,
    name: 'New Zealand',
    orderIndex: 160,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 161,
    name: 'Nicaragua',
    orderIndex: 161,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 162,
    name: 'Niger',
    orderIndex: 162,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 163,
    name: 'Nigeria',
    orderIndex: 163,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 164,
    name: 'Niue',
    orderIndex: 164,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 165,
    name: 'Norfolk Island',
    orderIndex: 165,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 166,
    name: 'Northern Mariana Islands',
    orderIndex: 166,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 167,
    name: 'Norway',
    orderIndex: 167,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 168,
    name: 'Oman',
    orderIndex: 168,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 169,
    name: 'Pakistan',
    orderIndex: 169,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 170,
    name: 'Palau',
    orderIndex: 170,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 171,
    name: 'Palestinian Territory, Occupied',
    orderIndex: 171,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 172,
    name: 'Panama',
    orderIndex: 172,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 173,
    name: 'Papua New Guinea',
    orderIndex: 173,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 174,
    name: 'Paraguay',
    orderIndex: 174,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 175,
    name: 'Peru',
    orderIndex: 175,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 176,
    name: 'Philippines',
    orderIndex: 176,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 177,
    name: 'Pitcairn',
    orderIndex: 177,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 178,
    name: 'Poland',
    orderIndex: 178,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 179,
    name: 'Portugal',
    orderIndex: 179,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 180,
    name: 'Puerto Rico',
    orderIndex: 180,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 181,
    name: 'Qatar',
    orderIndex: 181,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 182,
    name: 'Reunion',
    orderIndex: 182,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 183,
    name: 'Romania',
    orderIndex: 183,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 184,
    name: 'Russian Federation',
    orderIndex: 184,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 185,
    name: 'Rwanda',
    orderIndex: 185,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 186,
    name: 'Saint Helena',
    orderIndex: 186,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 187,
    name: 'Saint Kitts and Nevis',
    orderIndex: 187,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 188,
    name: 'Saint Lucia',
    orderIndex: 188,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 189,
    name: 'Saint Pierre and Miquelon',
    orderIndex: 189,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 190,
    name: 'Saint Vincent and the Grenadines',
    orderIndex: 190,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 191,
    name: 'Samoa',
    orderIndex: 191,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 192,
    name: 'San Marino',
    orderIndex: 192,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 193,
    name: 'Sao Tome and Principe',
    orderIndex: 193,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 194,
    name: 'Saudi Arabia',
    orderIndex: 194,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 195,
    name: 'Senegal',
    orderIndex: 195,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 196,
    name: 'Serbia',
    orderIndex: 196,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 197,
    name: 'Seychelles',
    orderIndex: 197,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 198,
    name: 'Sierra Leone',
    orderIndex: 198,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 199,
    name: 'Singapore',
    orderIndex: 199,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 200,
    name: 'Slovakia',
    orderIndex: 200,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 201,
    name: 'Slovenia',
    orderIndex: 201,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 202,
    name: 'Solomon Islands',
    orderIndex: 202,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 203,
    name: 'Somalia',
    orderIndex: 203,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 204,
    name: 'South Africa',
    orderIndex: 204,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 205,
    name: 'South Georgia and the South Sandwich Islands',
    orderIndex: 205,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 206,
    name: 'Spain',
    orderIndex: 206,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 207,
    name: 'Sri Lanka',
    orderIndex: 207,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 208,
    name: 'Sudan',
    orderIndex: 208,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 209,
    name: 'Suriname',
    orderIndex: 209,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 210,
    name: 'Svalbard and Jan Mayen',
    orderIndex: 210,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 211,
    name: 'Swaziland',
    orderIndex: 211,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 212,
    name: 'Sweden',
    orderIndex: 212,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 213,
    name: 'Switzerland',
    orderIndex: 213,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 214,
    name: 'Syrian Arab Republic',
    orderIndex: 214,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 215,
    name: 'Taiwan',
    orderIndex: 215,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 216,
    name: 'Tajikistan',
    orderIndex: 216,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 217,
    name: 'Tanzania, United Republic of',
    orderIndex: 217,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 218,
    name: 'Thailand',
    orderIndex: 218,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 219,
    name: 'Timor-Leste',
    orderIndex: 219,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 220,
    name: 'Togo',
    orderIndex: 220,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 221,
    name: 'Tokelau',
    orderIndex: 221,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 222,
    name: 'Tonga',
    orderIndex: 222,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 223,
    name: 'Trinidad and Tobago',
    orderIndex: 223,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 224,
    name: 'Tunisia',
    orderIndex: 224,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 225,
    name: 'Turkey',
    orderIndex: 225,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 226,
    name: 'Turkmenistan',
    orderIndex: 226,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 227,
    name: 'Turks and Caicos Islands',
    orderIndex: 227,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 228,
    name: 'Tuvalu',
    orderIndex: 228,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 229,
    name: 'Uganda',
    orderIndex: 229,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 230,
    name: 'Ukraine',
    orderIndex: 230,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 231,
    name: 'United Arab Emirates',
    orderIndex: 231,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 232,
    name: 'United Kingdom',
    orderIndex: 232,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 233,
    name: 'United States',
    orderIndex: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 234,
    name: 'United States Minor Outlying Islands',
    orderIndex: 234,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 235,
    name: 'Uruguay',
    orderIndex: 235,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 236,
    name: 'Uzbekistan',
    orderIndex: 236,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 237,
    name: 'Vanuatu',
    orderIndex: 237,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 238,
    name: 'Venezuela',
    orderIndex: 238,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 239,
    name: 'Viet Nam',
    orderIndex: 239,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 240,
    name: 'Virgin Islands, British',
    orderIndex: 240,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 241,
    name: 'Virgin Islands, U.S.',
    orderIndex: 241,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 242,
    name: 'Wallis and Futuna',
    orderIndex: 242,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 243,
    name: 'Western Sahara',
    orderIndex: 243,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 244,
    name: 'Yemen',
    orderIndex: 244,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 245,
    name: 'Zambia',
    orderIndex: 245,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 246,
    name: 'Zimbabwe',
    orderIndex: 246,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
];

export const STATE_DATA = [
  //
  // America states
  //
  {
    id: 1,
    name: 'Alabama',
    abbreviation: 'AL',
    orderIndex: 1,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 2,
    name: 'Alaska',
    abbreviation: 'AK',
    orderIndex: 2,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 3,
    name: 'Arizona',
    abbreviation: 'AZ',
    orderIndex: 3,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 4,
    name: 'Arkansas',
    abbreviation: 'AR',
    orderIndex: 4,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 5,
    name: 'California',
    abbreviation: 'CA',
    orderIndex: 5,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 6,
    name: 'Colorado',
    abbreviation: 'CO',
    orderIndex: 6,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 7,
    name: 'Connecticut',
    abbreviation: 'CT',
    orderIndex: 7,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 8,
    name: 'District of Columbia',
    abbreviation: 'DEC',
    orderIndex: 8,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 9,
    name: 'Delaware',
    abbreviation: 'DE',
    orderIndex: 9,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 10,
    name: 'Florida',
    abbreviation: 'FL',
    orderIndex: 10,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 11,
    name: 'Georgia',
    abbreviation: 'GA',
    orderIndex: 11,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 12,
    name: 'Hawaii',
    abbreviation: 'HI',
    orderIndex: 12,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 13,
    name: 'Idaho',
    abbreviation: 'ID',
    orderIndex: 13,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 14,
    name: 'Illinois',
    abbreviation: 'IL',
    orderIndex: 14,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 15,
    name: 'Indiana',
    abbreviation: 'IN',
    orderIndex: 15,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 16,
    name: 'Iowa',
    abbreviation: 'IA',
    orderIndex: 16,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 17,
    name: 'Kansas',
    abbreviation: 'KS',
    orderIndex: 17,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 18,
    name: 'Kentucky',
    abbreviation: 'KY',
    orderIndex: 18,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 19,
    name: 'Louisiana',
    abbreviation: 'LA',
    orderIndex: 19,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 20,
    name: 'Maine',
    abbreviation: 'ME',
    orderIndex: 20,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 21,
    name: 'Maryland',
    abbreviation: 'MD',
    orderIndex: 21,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 22,
    name: 'Massachusetts',
    abbreviation: 'MA',
    orderIndex: 22,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 23,
    name: 'Michigan',
    abbreviation: 'MI',
    orderIndex: 23,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 24,
    name: 'Minnesota',
    abbreviation: 'MN',
    orderIndex: 24,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 25,
    name: 'Mississippi',
    abbreviation: 'MS',
    orderIndex: 25,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 26,
    name: 'Missouri',
    abbreviation: 'MO',
    orderIndex: 26,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 27,
    name: 'Montana',
    abbreviation: 'MT',
    orderIndex: 27,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 28,
    name: 'Nebraska',
    abbreviation: 'NE',
    orderIndex: 28,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 29,
    name: 'Nevada',
    abbreviation: 'NV',
    orderIndex: 29,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 30,
    name: 'New Hampshire',
    abbreviation: 'NH',
    orderIndex: 30,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 31,
    name: 'New Jersey',
    abbreviation: 'NJ',
    orderIndex: 31,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 32,
    name: 'New Mexico',
    abbreviation: 'NM',
    orderIndex: 32,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 33,
    name: 'New York',
    abbreviation: 'NY',
    orderIndex: 33,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 34,
    name: 'North Carolina',
    abbreviation: 'NC',
    orderIndex: 34,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 35,
    name: 'North Dakota',
    abbreviation: 'ND',
    orderIndex: 35,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 36,
    name: 'Ohio',
    abbreviation: 'OH',
    orderIndex: 36,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 37,
    name: 'Oklahoma',
    abbreviation: 'OK',
    orderIndex: 37,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 38,
    name: 'Oregon',
    abbreviation: 'OR',
    orderIndex: 38,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 39,
    name: 'Pennsylvania',
    abbreviation: 'PA',
    orderIndex: 39,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 40,
    name: 'Rhode Island',
    abbreviation: 'RI',
    orderIndex: 40,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 41,
    name: 'South Carolina',
    abbreviation: 'SC',
    orderIndex: 41,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 42,
    name: 'South Dakota',
    abbreviation: 'SD',
    orderIndex: 42,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 43,
    name: 'Tennessee',
    abbreviation: 'TN',
    orderIndex: 43,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 44,
    name: 'Texas',
    abbreviation: 'TX',
    orderIndex: 44,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 45,
    name: 'Utah',
    abbreviation: 'UT',
    orderIndex: 45,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 46,
    name: 'Vermont',
    abbreviation: 'VT',
    orderIndex: 46,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 47,
    name: 'Virginia',
    abbreviation: 'VA',
    orderIndex: 47,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 48,
    name: 'Washington',
    abbreviation: 'WA',
    orderIndex: 48,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 49,
    name: 'West Virginia',
    abbreviation: 'WV',
    orderIndex: 49,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 50,
    name: 'Wisconsin',
    abbreviation: 'WI',
    orderIndex: 50,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 51,
    name: 'Wyoming',
    abbreviation: 'WY',
    orderIndex: 51,
    countryId: 233,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  //
  // Canada states
  //
  {
    id: 52,
    name: 'Alberta',
    abbreviation: 'AB',
    orderIndex: 52,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 53,
    name: 'British Columbia',
    abbreviation: 'BC',
    orderIndex: 53,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 54,
    name: 'Manitoba',
    abbreviation: 'MB',
    orderIndex: 54,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 55,
    name: 'New Brunswick',
    abbreviation: 'NB',
    orderIndex: 55,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 56,
    name: 'Newfoundland and Labrador',
    abbreviation: 'NL',
    orderIndex: 56,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 57,
    name: 'Northwest Territories',
    abbreviation: 'NT',
    orderIndex: 57,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 58,
    name: 'Nova Scotia',
    abbreviation: 'NS',
    orderIndex: 58,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 59,
    name: 'Nunavut',
    abbreviation: 'NU',
    orderIndex: 59,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 60,
    name: 'Ontario',
    abbreviation: 'ON',
    orderIndex: 60,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 61,
    name: 'Prince Edward Island',
    abbreviation: 'PE',
    orderIndex: 61,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 62,
    name: 'Quebec',
    abbreviation: 'QC',
    orderIndex: 62,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 63,
    name: 'Saskatchewan',
    abbreviation: 'SK',
    orderIndex: 63,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 64,
    name: 'Yukon Territory',
    abbreviation: 'YT',
    orderIndex: 64,
    countryId: 39,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  //
  // Australia states
  //
  {
    id: 65,
    name: 'Australian Capital Territory',
    abbreviation: 'ACT',
    orderIndex: 65,
    countryId: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 66,
    name: 'New South Wales',
    abbreviation: 'NSW',
    orderIndex: 66,
    countryId: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 67,
    name: 'Northern Territory',
    abbreviation: 'NT',
    orderIndex: 67,
    countryId: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 68,
    name: 'Queensland',
    abbreviation: 'QLD',
    orderIndex: 68,
    countryId: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 69,
    name: 'South Australia',
    abbreviation: 'SA',
    orderIndex: 69,
    countryId: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 70,
    name: 'Tasmania',
    abbreviation: 'TAS',
    orderIndex: 70,
    countryId: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 71,
    name: 'Victoria',
    abbreviation: 'VIC',
    orderIndex: 71,
    countryId: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
  {
    id: 72,
    name: 'Western Australia',
    abbreviation: 'WA',
    orderIndex: 72,
    countryId: 14,
    createdAt: '2019-04-30T09:10:42.082Z',
    updatedAt: '2019-04-30T09:10:42.082Z',
  },
];
